"use strict";
/* eslint-disable react/jsx-props-no-spreading */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDownloadFile = void 0;
exports.createDownloadFile = function (_a) {
    var file = _a.file, name = _a.name, bearer = _a.bearer;
    try {
        if (file) {
            var headers = {
                Authorization: bearer,
                'cache-control': 'force-cache',
                cache: 'force-cache',
            };
            fetch(file, {
                cache: 'force-cache',
                headers: headers,
                method: 'GET',
            })
                .then(function (response) { return response.blob(); })
                .then(function (data) {
                var source = URL.createObjectURL(data);
                var a = document.createElement('a');
                a.href = source;
                a.target = '_blank';
                a.setAttribute('download', name);
                a.click();
            })
                .catch(function (e) {
                console.log('createDownloadFile', e);
            });
        }
    }
    catch (e) {
        console.log('createDownloadFile', e);
    }
};
//# sourceMappingURL=createDownloadFile.js.map